import React from 'react';
import { toValidNumber } from '../../utils/helpers';
import { SocialPost } from 'types/collaboration';

interface SocialPostCardProps {
    post: SocialPost;
    modal?: any;
    onPostClick: (postId: string) => void;
    newStyle?: boolean
}

const SocialPostCard: React.FC<SocialPostCardProps> = ({ post, onPostClick, newStyle }) => {
    const handleClick = () => {
        onPostClick(post.uuid);
    };

    const formatNumber = (number: number): string => {
        const decimals = 2;
        const valueIfNaN = '-';
        const orderSuffixes = ['', 'k', 'M', 'B', 'T'];
        const minOrder = 0;
        const maxOrder = Infinity;

        let x = parseFloat(number.toString());

        if (isNaN(x)) return valueIfNaN;

        let order;
        if (!isFinite(x)) order = 0;
        else {
            const unboundedOrder = Math.floor(Math.log10(Math.abs(x)) / 3);
            order = Math.max(0, minOrder, Math.min(unboundedOrder, maxOrder, orderSuffixes.length - 1));
        }

        const orderSuffix = orderSuffixes[order];
        if (order !== 0) x /= Math.pow(10, order * 3);

        const style: '' | '$' = ''; // Declare the type explicitly here
        return (
            (style !== '' ? '$' : '') +
            x.toLocaleString('en-US', {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: decimals,
            }) +
            orderSuffix
        );
    };


    return (
        <div>
            {post.type !== 'STORY' ? (
                <div
                    className="post-box"
                    style={{
                        backgroundImage: `url(${post.thumbnail_url})`,
                        position: 'relative',
                    }}
                    onClick={handleClick}
                >
                    <div className="post-stats text-white fw-bold d-flex align-items-center flex-column">
                        <div className={`mt-auto p-2 ${newStyle ? 'pb-5' : ''} d-flex flex-row`}>
                            <span className="p-2 d-flex flex-column align-items-center">
                                <i className="ri-heart-fill"></i>{formatNumber(toValidNumber(post.like_count))}
                            </span>
                            <span className="p-2 d-flex flex-column align-items-center">
                                <i className="ri-chat-1-fill"></i> {formatNumber(toValidNumber(post.comments_count))}
                            </span>
                            <span className="p-2 d-flex flex-column align-items-center">
                                <i className="ri-eye-fill"></i> {formatNumber(toValidNumber(post?.views_count))}
                            </span>
                            {/* <span className="p-2 d-flex flex-column align-items-center">
                                <i className="fa-solid fa-share-nodes"></i> {formatNumber(toValidNumber(post.ig?.shares_count))}
                            </span> */}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="mb-1" style={{ position: 'relative' }} onClick={handleClick}>
                    <img src={post.thumbnail_url} className="img-fluid " alt="Post Thumbnail" />
                    <div className=" bg-dark post-story-date text-white d-flex flex-column align-items-center p-2">
                        <span className="d-inline-block px-2 fw-bolder fs-3 text-white">{post.date}</span>
                        <span className="d-inline-block px-2 fs-6 text-white">{post.month}</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SocialPostCard;